import React, { ChangeEvent, useMemo } from "react";
import { useIntl } from "react-intl";
import { faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AccommodationType } from "@shared/models/article";
import "./search-sort.scss";

const values: Record<string, any> = {
  "name-asc": { title: "ASC" },
  "name-desc": { title: "DESC" },
  "price-asc": { price: "ASC" },
  "price-desc": { price: "DESC" },
  "guests-asc": { guests: "ASC" },
  "guests-desc": { guests: "DESC" },
  "rooms-asc": { rooms: "ASC" },
  "rooms-desc": { rooms: "DESC" },
  "surface-asc": { surface: "ASC" },
  "surface-desc": { surface: "DESC" },
}

type SearchSortProps = {
  type: AccommodationType,
  data?: any,
  onChange?: (value?: any) => void
}

const SearchSort = (
  {
    type,
    data,
    onChange = () => void 0
  }: SearchSortProps) => {

  const intl = useIntl();

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) =>
    onChange(values[e.target.value] || undefined);

  const value = useMemo(() => {
    const index = Object.values(values).findIndex(value => value === data);
    return index >= 0 ? Object.keys(values)[index] : "";
  }, [data ]);

  return (
    <div className="sort-container">
      <FontAwesomeIcon icon={faSort} />
      {`${intl.formatMessage({ id: "search-sort-label", defaultMessage: "Trier par"})}:`}
      <select value={value} onChange={handleChange}>
        <option value="">
          {intl.formatMessage({ id: "search-sort-default", defaultMessage: "Défaut" })}
        </option>
        <option value="name-asc">
          {intl.formatMessage({ id: "search-sort-name", defaultMessage: "Nom (ordre croissant)" })}
        </option>
        <option value="name-desc">
          {intl.formatMessage({ id: "search-sort-name-desc", defaultMessage: "Nom (ordre décroissant)" })}
        </option>
        <option value="price-asc">
          {intl.formatMessage({ id: "search-sort-price", defaultMessage: "Prix (le - cher en premier)" })}
        </option>
        <option value="price-desc">
          {intl.formatMessage({ id: "search-sort-price-desc", defaultMessage: "Prix (le + cher en premier)" })}
        </option>
        {[ AccommodationType.RENTAL, AccommodationType.SEASONAL].includes(type) &&
          <>
            <option value="guests-asc">
              {intl.formatMessage({ id: "search-sort-guests", defaultMessage: "Personnes (ordre croissant)" })}
            </option>
            <option value="guests-desc">
              {intl.formatMessage({ id: "search-sort-guests-desc", defaultMessage: "Personnes (ordre décroissant)" })}
            </option>
          </>
        }
        {[ AccommodationType.ANNUAL, AccommodationType.SALE ].includes(type) &&
          <>
            <option value="surface-asc">
              {intl.formatMessage({ id: "search-sort-surface", defaultMessage: "Surface (order croissant)" })}
            </option>
            <option value="surface-desc">
              {intl.formatMessage({ id: "search-sort-surface-desc", defaultMessage: "Surface (order décroissant)" })}
            </option>
            <option value="rooms-asc">
              {intl.formatMessage({ id: "search-sort-rooms", defaultMessage: "Pièces (order croissant)" })}
            </option>
            <option value="rooms-desc">
              {intl.formatMessage({ id: "search-sort-rooms-desc", defaultMessage: "Pièces (ordre décroissant)" })}
            </option>
          </>
        }
      </select>
    </div>);

};

export default SearchSort;
